import { render, staticRenderFns } from "./videoface.vue?vue&type=template&id=15f05d6a&"
import script from "./videoface.vue?vue&type=script&lang=js&"
export * from "./videoface.vue?vue&type=script&lang=js&"
import style0 from "./videoface.vue?vue&type=style&index=0&lang=scss&scped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports